module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[],"loading":"eager"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
